











import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { IDocumentReferable } from "../../../../domain/document";
import { IContentSource } from "../../../../domain/drawing";
import { ModelEditableMixin } from "../../../system/mixins";
import { DeveloperPresentableMixin } from "../../mixins";
import { DebugPdfPreviewDialog } from "./dialogs";

@Component({
  components: {
    DebugPdfPreviewDialog,
  }
})
export default class DebugTool extends Mixins(ModelEditableMixin, DeveloperPresentableMixin) {
  @Prop()
  document: IDocumentReferable;

  editDocument(): void {
    // 開発効率向上のために別タブで文書編集できるようにしている。
    // 本来であれば編集可能かどうかのチェックをしたほうがよさそう。
    this.$openWindow(
      "/EditDocument",
      {
        patientNo: this.document.patientNo,
        documentId: this.document.id.toString(),
      }
    );
  }

  async showOriginalPdf(): Promise<void> {
    await this.showPdf(await DomainRegistry.developer.getDocumentService().createOriginalSource(this.document));
  }

  async showPreviewPdf(): Promise<void> {
    await this.showPdf(await DomainRegistry.developer.getDocumentService().createPreviewSource(this.document));
  }

  async showPrintPdf(): Promise<void> {
    await this.showPdf(await DomainRegistry.developer.getDocumentService().createPrintSource(this.document));
  }

  async showPdf(source: IContentSource): Promise<void> {
    await (this.$refs.preview as DebugPdfPreviewDialog).show(source);
  }
}
